export const Constants = {
    SERVICE_CO_PILOT_URL: 'https://si-copilot-fe-166340deb7fa.herokuapp.com',
};
